import { render } from "./UpdateComplete.vue?vue&type=template&id=039215d3"
import script from "./UpdateComplete.vue?vue&type=script&lang=js"
export * from "./UpdateComplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__